(function ($, window) {
    'use strict';

    window.AdminKit = window.AdminKit || {};

    window.AdminKit.dropdown = {
        init: function () {
            $(document).on('click', '.dropdown-toggle', function (event) {
                event.stopPropagation();

                var $menu = $(this).closest('.dropdown').find('> .dropdown-menu');

                $('.dropdown-menu').not($menu).removeClass('show');
                $menu.toggleClass('show');
            });

            $(document).on('click', function () {
                $('.dropdown-menu').removeClass('show');
            });

            $(document).on('click', '.dropdown-menu', function (event) {
                event.stopPropagation();
            });
        }
    };
})(jQuery, window);
